<template>
  <div v-if="isLoaded" id="Subsidy">
    <Hero class="lift" :formats="['webp']" src="../../../assets/subsidy-hero.jpg">
      <h1>{{ support.title }}</h1>
    </Hero>
    <section id="content">
      <Wrap>
        <Markdown :hasStyles="true" :markdown="support.content" />
      </Wrap>
    </section>
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'

const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  mixins: [
    Meta(
      undefined,
      ({ support }) => support?.content,
      require('@/assets/social/support.jpg'),
    ),
  ],
  components: { Hero, Markdown },
  computed: {
    support() {
      return this.query('page', {
        locale: this.locale,
        type: 'SUPPORT',
      }, true)
    },
    ...getters(),
  },
  methods: actions('FETCH_PAGE'),
  created() {
    this.LOAD(this.FETCH_PAGE())
  },
}
</script>

<style lang="scss">
#Subsidy {
  .Hero {
    .image img {
      filter: brightness(0.7);
    }
  }

  #content {
    background-color: $white;
  }
}
</style>

<i18n>
{
  "en": {},
  "lt": {
    "meta": {
      "title": {
      "complement": "Nogrid",
      "inner": "APVA parama saulės elektrinėms",
      "separator": "-"
      }
    }
  },
  "pl": {}
}
</i18n>
